import React, { Component } from "react";
import { connect } from 'react-redux';
import { Link } from 'react-router';
import logo from '../../../assets/images/brand-logo.svg';
import userIcon from '../../../assets/images/icon-user.svg';
import angleLeftIcon from '../../../assets/images/angle-left.svg';
import { accountLinks } from "../constants";
import { disabledCart, adminUserIds } from '../../../utils/utils';
import { getFeaturedBannerList, getMainBannerList } from '../../../actions/CmsActions';
import { getProhibitedParcel, getNotification, readNotification, readAllNotification } from '../../../actions/ParcelAction';
import NotificationMenu from "./NotificationMenu";
import './header.scss';
import '../../../../public/css/media/_notification-icon.scss';
import SecondaryMenu from "./SecondaryMenu";
import { handleAppUrl } from "../../../utils/urls";

class Header extends Component {
  state = {
    notification: "",
    enabledCart: false
  }

  componentWillMount() {
    this.props.getFeaturedBannerList();
    this.props.getMainBannerList();
    if (localStorage.jwtToken) {
      this.props.getProhibitedParcel(localStorage.jwtToken);
    }
  }

  componentWillReceiveProps(nextProps){
    if (nextProps.isAuthenticated && nextProps.login.fetched && this.props.login.fetched && !nextProps.parcel.notification_error){
      if((nextProps.parcel.getProhibited !== this.props.parcel.getProhibited) && !this.props.parcel.notification){
        this.props.getNotification(nextProps.login.login.party.party_id)
      }
      if (nextProps.parcel.notification){
        const notification = nextProps.parcel.notification_fetched ? nextProps.parcel.notification.data.filter(notif => notif.attributes.read === 0) : null;
        this.setState({notification})
      }
    }
    if(nextProps.login.fetched && nextProps.login.login.party){
      const enabledCart = adminUserIds.find(e => e === nextProps.login.login.party.account_number)
      this.setState({ enabledCart: enabledCart ? true : false})
    }
  }

  // handleTrackPackage() {
  //   localStorage.setItem("trackPackage", "true");
  // }

  renderFirstName = () => {
    let firstName = '';
    if (this.props.login && this.props.login.login.party && this.props.login.login.party.first_name) {
      firstName = this.props.login.login.party.first_name;
    }
    return firstName;
  }
  renderAccountNumber = () => {
    let accountNumber = '';
    if (this.props.login && this.props.login.login.party && this.props.login.login.party.account_number) {
      accountNumber = this.props.login.login.party.account_number;
    }
    return accountNumber;
  }
  renderProhibitedMenuItem = () => {
    if (this.props.parcel.parcel_fetching) return
    if (this.props.parcel.prohibited && this.props.parcel.prohibited.data.length > 0) {
      return <li>
      <Link to="/prohibited">Prohibited Items</Link>
    </li>
    }
  }
  
  render () {
    return <div className="nav-wrapper">
      <div className="primary-nav-wrapper">
        <div className="primary-nav">
          <Link to='/'>
            <img alt="icon" src={logo}/>
          </Link>
        <div>
      </div>
      <div style={{display: 'flex'}}>
        <ul className="primary-nav-links">
          <li><Link to='/how-it-works' className="primary-nav-link">How it works</Link></li>
          <li >
            <Link className="primary-nav-link" to={`${handleAppUrl()}/shipping-estimate`} target='_blank'>Shipping Estimate</Link>
          </li>
          <li><Link className="primary-nav-link" to={`${handleAppUrl()}/track`} target='_blank'>Track Your Package</Link></li>
          {/* <li className="primary-nav-link">Search</li> */}
        </ul>
        { 
          this.props.isAuthenticated || localStorage.jwtToken ? 
            <div style={{marginLeft: 20, display: 'flex'}}>
              <NotificationMenu
                isAuthenticated={this.props.isAuthenticated}
                notification={this.state.notification}
                readAllNotification={this.props.readAllNotification}
                readNotification={this.props.readNotification} />
              <img alt="icon" src={userIcon} style={{ paddingLeft: 20, marginRight: 10 }} />
              <div className="dropdown cursor-pointer">
                <p className="dropdown-toggle" data-toggle="dropdown" style={{
                  margin: 0,
                  whiteSpace: 'nowrap',
                  height: '67px',
                  display: 'flex',
                  alignItems: 'center',
                  fontSize: '16px'
                }}>Hello! {this.renderFirstName()}
                  <span className="margin-left-10"><img alt="icon" src={angleLeftIcon}/></span>
                </p>
              <ul className="dropdown-menu primary-nav-links-wrapper ">
                { accountLinks.map((link,i) => <li key={i}><Link to={link.route} className={disabledCart && link.route === '/cart' ? 'isDisabled' : ''}>{link.label}</Link></li>) }
                {this.renderProhibitedMenuItem()}
                <li><Link to="/" onClick={this.props.logout}> Logout </Link></li>
              </ul>
              </div>
            </div> : 
            <div className="flex-container" style={{ alignItems: 'center', height: 67 }}>
              <Link to={`${handleAppUrl()}/sign-in`} target="_blank" style={{ color: '#AA0E0E', fontWeight: 600, padding: '5px 20px', borderRight: '1px solid #E2E2E2', fontSize: 16 }}>SIGN IN</Link>
              <Link to={`${handleAppUrl()}/sign-up`} target="_blank" style={{ color: '#AA0E0E', fontWeight: 600, border: '1px solid #AA0E0E', borderRadius: 25, marginLeft: 20, padding: '5px 20px', fontSize: 16 }}>SIGN UP</Link>
            </div>
        }
        
      </div>
      </div>
      </div>
      <SecondaryMenu accountNumber={this.renderAccountNumber()} firstName={this.renderFirstName()}/>
    </div>
  }
}

const mapDispachToProps = { 
  getFeaturedBannerList, 
  getMainBannerList, 
  getProhibitedParcel, 
  getNotification, 
  readNotification, 
  readAllNotification }

const mapStateToProps = state => ({
  cms: state.cms,
  parcel: state.parcel,
})

export default connect(mapStateToProps, mapDispachToProps)(Header)


/** WEBPACK FOOTER **
 ** ./src/components/Layout/Header/index.js
 **/